import gql from "graphql-tag";

export const searchRanking = gql`
  query Query($getKeywordRankInput: getKeywordRankInput!) {
    getSearchRank(getKeywordRankInput: $getKeywordRankInput)
  }
`;
export const deleteKeyword = gql`
  query Query($domain: String!, $keyword: String!) {
    deleteKeyword(domain: $domain, keyword: $keyword)
  }
`;
